import { businessApi } from '@/api/listHelperApi';
import { useQuery } from '@tanstack/react-query';

export function useBusinessSectors() {
  return useQuery({
    queryKey: ['business', 'sectors'],
    queryFn: () => businessApi.getSectors({ limit: 100, page: 1 }),
    staleTime: Infinity,
    select: (data) => data.data, // trả thẳng mảng
  });
}

export function useBusinessTypes(sectorId?: string) {
  return useQuery({
    queryKey: ['business', 'types', sectorId],
    queryFn: () => businessApi.getTypes({ limit: 100, page: 1, sectorId }),
    staleTime: Infinity,
    select: (data) => data.data,
    // Nếu không truyền sectorId thì lấy tất cả
  });
}
